import { DefineGetters } from "vuex-type-helper";
import { NotificationGetters, NotificationState } from "./types";

export const getters: DefineGetters<NotificationGetters, NotificationState> = {
  getTotalRecords: ({ links, notifications }: NotificationState) =>
    links && links.totalRecords ? links.totalRecords : notifications.length
};
